import React from 'react';
import { Form, Input } from 'antd';
import { getLangList } from "@/lib/i18n";
import { modalFromLayout } from "@/lib/antdElementFunction";

interface props {
  form: any;
}

class ModalChangePassword extends React.Component<props> {
  profileInfoT: any = getLangList("profileInfo");

  render() {
    const { form } = this.props;

    return (
      <Form {...modalFromLayout} form={form}>
        <Form.Item label={this.profileInfoT.OLD_PASSWORD} name="originPassword">
          <Input.Password />
        </Form.Item>

        <Form.Item label={this.profileInfoT.NEW_PASSWORD} name="newPassword">
          <Input.Password />
        </Form.Item>

        <Form.Item label={this.profileInfoT.CHECK_PASSWORD} name="checkNewPassword">
          <Input.Password />
        </Form.Item>
      </Form>
    );
  }
}

export default ModalChangePassword;